import * as Dialog from "@radix-ui/react-dialog";
import closeIcon from "../assets/images/close.svg";

export default function BuyerInfoModal({ open, onOpenChange, buyer }) {
  if (!buyer) return null;

  const updateImageStyles = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const promoDivs = tempDiv.querySelectorAll(".promo > div");

    promoDivs.forEach((div) => {
      div.style.margin = "20px 0";

      const img = div.querySelector("img");
      if (img) {
        img.style.margin = "auto";
        img.style.display = "block";
      }
    });

    return tempDiv.innerHTML;
  };

  // Hardcoded buyer descriptions
  const getBuyerContent = () => {
    const buyerName = buyer.name?.toLowerCase();

    if (buyerName.toLowerCase().includes("insurify")) {
      return {
        title: "About Insurify",
        description:
          "We can help you save up to $1100 on your insurance needs. Whether you prefer to buy online or want expert guidance, Insurify makes it easy to find your perfect policy. No spam. No fees. Just better insurance and bigger savings.",
        compareText: "Compare Quotes From:",
        logos: [
          { name: "State Farm", url: "/logos/statefarm.png" },
          { name: "Progressive", url: "/logos/progressive.png" },
          { name: "Allstate", url: "/logos/allstate.png" },
          { name: "Liberty Mutual", url: "/logos/liberty.png" },
          { name: "Farmers", url: "/logos/farmers.png" },
          { name: "The General", url: "/logos/thegeneral.png" },
        ],
        additionalText: "+120 more",
      };
    } else if (buyerName === "simplyioa") {
      return {
        title: "About SimplyIOA",
        description:
          "We provide hands-on and personalized service to our customers across the United States, helping them compare, purchase, and save big on insurance from the Sunshine State to the Golden State.",
        compareText: "Compare Quotes From:",
        logos: [
          { name: "Progressive", url: "/logos/progressive.png" },
          { name: "Allstate", url: "/logos/allstate.png" },
          { name: "Nationwide", url: "/logos/nationwide.png" },
          { name: "Travelers", url: "/logos/travelers.png" },
          { name: "Mercury Insurance", url: "/logos/mercury.png" },
          { name: "The Hartford", url: "/logos/hartford.png" },
          { name: "Auto Owners", url: "/logos/autoowners.png" },
          { name: "Chubb", url: "/logos/chubb.png" },
          { name: "Kemper", url: "/logos/kemper.png" },
        ],
        additionalText: "and many more",
      };
    } else if (buyerName === "rein") {
      return {
        title: "About Rein",
        description:
          "Rein connects you with top-rated insurance carriers to find the best coverage at competitive rates. Their licensed agents compare multiple carriers to get you the right policy.",
        compareText: "Compare Quotes From:",
        logos: [
          { name: "Geico", url: "/logos/geico.png" },
          { name: "Progressive", url: "/logos/progressive.png" },
          { name: "Liberty Mutual", url: "/logos/liberty.png" },
        ],
        additionalText: "and more",
      };
    }

    // Fallback to original implementation
    return null;
  };

  const buyerContent = getBuyerContent();

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex sm:items-center sm:justify-center items-end justify-center">
          <Dialog.Content
            className="sm:max-w-md sm:max-w-[400px] sm:mx-4 sm:rounded-2xl rounded-t-2xl bg-white px-4 pt-3 pb-6 shadow-xl relative flex flex-col
              sm:bottom-auto sm:translate-y-0 bottom-0 translate-y-0
              animate-in fade-in-90 slide-in-from-bottom-8"
            style={{ maxWidth: "100vw" }}
          >
            <Dialog.Close asChild>
              <button
                className="absolute top-4 outline-none right-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full"
                aria-label="Close"
              >
                <img src={closeIcon} alt="Close" className="w-6 h-6" />
              </button>
            </Dialog.Close>
            <div className="flex flex-col items-center">
              <div className="w-12 h-1.5 bg-gray-200 rounded-full m-auto mb-4 sm:hidden" />
              <div className="w-20 h-20 bg-violet-100 rounded-full flex items-center justify-center mx-auto !my-2">
                <img
                  className="w-full h-full object-contain"
                  src={buyer.logo}
                  alt="buyerLogo"
                />
              </div>

              {buyerContent ? (
                // Hardcoded content for Insurify and SimplyIOA
                <div className="text-sm mt-2 w-full text-center space-y-4">
                  <div>
                    <h3 className="font-bold text-base mb-2">
                      {buyerContent.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {buyerContent.description}
                    </p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-sm mb-3">
                      {buyerContent.compareText}
                    </h4>

                    {/* Logo grid - show first 4 logos in 2x2 grid */}
                    <div className="grid grid-cols-3 gap-2 mb-3">
                      {buyerContent.logos.slice(0, 9).map((logo, index) => (
                        <div
                          key={index}
                          className="bg-gray-50 rounded p-2 flex flex-col items-center justify-center border"
                        >
                          <div className="h-16 flex items-center justify-center mb-1">
                            <img
                              src={logo.url}
                              alt={logo.name}
                              className="max-h-16 max-w-full object-contain"
                              onError={(e) => {
                                // Fallback if logo doesn't load
                                if (e.target) {
                                  e.target.style.display = "none";
                                  e.target.parentElement.nextElementSibling.style.display =
                                    "block";
                                }
                              }}
                            />
                          </div>
                          {/* <span className="text-xs text-gray-700 font-medium text-center leading-tight">
                            {logo.name}
                          </span> */}
                        </div>
                      ))}
                    </div>

                    {/* Additional text */}
                    <p className="text-xs text-gray-500 italic">
                      {buyerContent.additionalText}
                    </p>
                  </div>
                </div>
              ) : (
                // Fallback to original implementation
                <div
                  className="buyer-description text-sm mt-2 w-full text-center"
                  dangerouslySetInnerHTML={{
                    __html: updateImageStyles(buyer.description),
                  }}
                />
              )}
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
